import Modal from '@mui/material/Modal';
import { useEffect, useState, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import ExpPackPayment from "./ExpPackPayment.js";
import 'react-circular-progressbar/dist/styles.css';
import CheckoutForm from '../../../components/CheckoutForm.js';
import { toggleModal } from "../../../reducers/modalReducer.js";
import { updateModule } from '../../../reducers/moduleReducer.js';
import { getRequest, showMessage } from '../../../config.js';
import DirectorQuestionnaireDisclaimer from '../../../components/modals/directorQuestionnaireDisclaimer/index.jsx';
import WhatToDoNextModal from '../../../components/modals/WhatToDoNextModal/WhatToDoNextModal.js';
import WhatYouGetModal from '../../../components/modals/WhatYouGetModal/WhatYouGetModal.js';
import SubscriptionPaymentConfirm from '../../../components/modals/SubscriptionPaymentConfirm/SubscriptionPaymentConfirm.jsx';
import CoreModuleCard from '../../../components/ModuleCardNew/ModuleCard.js';
import HowItWorkModal from '../../../components/modals/HowItWorkModal/index.js';
import SectionTitle from './dashboard/components/SectionTitle.js';

export default function Dashboard({ investorFirmCounts, company, setTab, setIsViewTwoMinuteReport, isWorkflowReport, setIsWorkflowReport, permissionLevel, getFitInvestorFirms, selectedSeeMore, setSelectedSeeMore, setCompanyDashboardTab, setCertificateSeeMore, isGenerateAllResearchAid, fitInvestorFirms }) {

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const user = useSelector(state => state.user);
	const modal = useSelector(state => state.modal);
	const modalJustClosedRef = useRef(false);
	let [isSwotReport, setIsSwotReport] = useState(false);
	let [plan, setPlan] = useState();
	let [payload, setPayload] = useState(null);
	let [companyId, setCompanyId] = useState("");
	let [showExpension, setShowExpension] = useState(null);
	let [reportTab, setReportTab] = useState(null);
	// let [selectedSeeMore, setSelectedSeeMore] = useState({});
	let [selectedModules, setSelectedModules] = useState(null);
	let [selectedHowItWorks, setSelectedHowItWorks] = useState({});
	let [selectedThingsToDo, setSelectedThingsToDo] = useState({});
	let [expanded, setExpanded] = useState({ investmentPanel: false, growthPanel: false, exitPanel: false });
	// OPTIMIZATION: Lazy load directors when not available (excluded in lightweight mode)
	let [directors, setDirectors] = useState(company?.['directors'] || []);
	let [dashboardCards, setDashboardCards] = useState(null);
	useEffect(() => {
		if (company['researchAidReports'] && company['researchAidReports'].length > 0) {
			const report = company?.['researchAidReports'].filter((item) => item?.['reportType'] === "swotAnalysis")?.[0]
			if (report?.['disableSwotReport']) setIsSwotReport(true);
			else setIsSwotReport(false);
		}
	}, [company])

	const getDashboardCards = useCallback(async () => {
		try {
			const response = await getRequest(`/modules/dashboard-cards?modules=true&sections=true&companyId=${company?.['_id']}`);
			if (response?.code === 200) return response?.body;
		} catch (e) {
			console.error('Failed to fetch dashboard cards:', e);
		}
		return null;
	}, [company?._id]);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			const body = await getDashboardCards();
			if (!cancelled) setDashboardCards(body);
		})();
		return () => {
			cancelled = true;
		};
	}, [getDashboardCards]);

	// Fetch directors if not available (excluded in lightweight mode)
	const fetchDirectors = async () => {
		try {
			const response = await getRequest(`/company/${company._id}/directors`);
			if (response['code'] === 200 && response['body']) {
				setDirectors(response['body']['directors'] || []);
			}
		} catch (e) {
			console.error('Failed to fetch directors:', e);
		}
	};
	useEffect(() => {
		fetchDirectors();
	}, [company?._id, company?.['directors'], company?.['directorsCount']]);

	useEffect(() => {
		if (window.localStorage.getItem('expandedPanels')) {
			const storedStates = JSON.parse(window.localStorage.getItem('expandedPanels'));
			setExpanded(storedStates);
		}
		let isManualAdd = localStorage.getItem('isManualAdd');
		if (isManualAdd) localStorage.removeItem('isManualAdd');
	}, []);

	const setModuleTab = async (setTab, type, module) => {
		if (modal['open'] === "" && ((type.startsWith('two-minute-') && !company['freeModules']) || (company['freeModules'] && !company['freeModules'][type])) && !type.startsWith('repository')) {
			setShowExpension(type);
			setPayload({ setTab, type, module })
			if (module && module['sectionStats']) {
				const key = Object.keys(module['sectionStats'])[0];
				const code = key.split(" - ")[1]
				if (company['expansionPack'] && !company['expansionPack'][code]) {
					return dispatch(toggleModal({ open: 'subscriptionPaymentConfirm' }))
				}
			}

		}

		// CHECK KPI & CERTIFICATE FOR GUEST USERS
		if (user?.['role'] == 'Guest') {
			dispatch(toggleModal({ open: 'noRegistrationReport' }))
			return;
		}

		// CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
		if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT') && (type && !(['kpi-report', 'benchmark-reporting'].includes(type)))) {
			showMessage(`You have ${permissionLevel} access only!`);
			return;
		}

		if (['software-development', 'esg', 'warranty-disclosure', 'directors-questionnaire'].includes(type)) {
			// CHECK EXPANSION PACK PERMISSIONS FOR MEMBERS
			const message = `You don't have permission for this module. Please contact your admin ${company['creatorId']['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] ? company['creatorId']['lastName'] : ""}` : 'user'} to gain access`
			if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
				if (!(company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']])) {
					showMessage(message);
					return;
				}
			}
			// CHECK EXPANSION PACK PERMISSIONS FOR ADVISORS/INVESTORS
			if ((user['role'] == "Advisor" || user['role'] == 'Investor') && company['creatorId']['_id'] != user['_id']) {
				if (!(company?.[user['role'] == "Investor" ? 'investors' : 'advisors']?.[user['_id']]?.['modules']?.[module?.['sections']?.[0]?.['sectionNo']])) {
					showMessage(message);
					return;
				}
			}
		}

		if (type.includes("directors-questionnaire")) {
			if (localStorage.getItem('isDirectoreDisclaimer')) dispatch(toggleModal({ open: 'showDirectors' }));
			else {
				localStorage.setItem('isDirectoreDisclaimer', true);
				dispatch(toggleModal({ open: 'directorQuestionnaireDisclaimer' }));
			}
			return;
		}
		else {
			setTab(type);
			if (module) dispatch(updateModule(module));
		}
	};

	useEffect(() => {
		if (isWorkflowReport && !window.location.hash.includes('#workflow')) setIsWorkflowReport(false);
	}, []);

	const onModalClose = () => {
		dispatch(toggleModal({ open: '' }));
		setSelectedSeeMore({});
		setSelectedHowItWorks({});
		// Set flag to prevent navigation immediately after modal close
		modalJustClosedRef.current = true;
		setTimeout(() => {
			modalJustClosedRef.current = false;
		}, 300); // 300ms delay to prevent navigation from modal close click events
	};

	// Track modal state changes to detect when modal closes
	useEffect(() => {
		if (modal && !modal['open']) {
			// Modal was just closed
			modalJustClosedRef.current = true;
			const timer = setTimeout(() => {
				modalJustClosedRef.current = false;
			}, 300);
			return () => clearTimeout(timer);
		}
	}, [modal]);


	return (
		<>
			{/* For Company Subscription */}
			<CheckoutForm plan={plan} company={company} companyId={companyId} />
			{/* For Module Buy */}
			<ExpPackPayment {...{ user, company, showExpension }} />
			{
				dashboardCards && dashboardCards?.['cards'] && dashboardCards?.['cards']?.length > 0 && (
					<div className='df fdc'>
						{dashboardCards?.['cards']?.map((card, index) => {
							const hasImage = !!card?.['imageURL'];

							return (
								<div key={index} className="box-dashbord-contaxiner mla mra my1rem" style={{ width: '98%' }}>
									<div className={`bg20 bss bo5 bsbb px2rem py2rem br25px w100 ${user?.['role'] == 'Guest' ? 'bo3' : 'bo28'} keyfeature-box keyfeature-box-company-${company['subscription'].toLowerCase()} df fdc pr bsbb bw1px`} style={{ backgroundColor: '#EEFFF7' }}>
										{!hasImage && (
											<div className="w100 mb1rem">
												<SectionTitle title={card?.['title']} subtitle={card?.['subTitle']} />
											</div>
										)}
										<div className="df aifs jcsb">

											{hasImage && (
												<div className="df jcsb aic fdc" style={{ width: '25%' }}>
													<SectionTitle title={card?.['title']} subtitle={card?.['subTitle']} />
													<div className='df jcc aic w100 h100'>
														<img src={card?.['imageURL']} style={{ width: '230px', height: '251px' }} alt="dashboardIcon" />
													</div>
												</div>
											)}

											<div className={`dg gg1rem ${hasImage ? 'gtcr3' : 'gtcr4'} w80`} style={{ width: hasImage ? '75%' : '100%' }}>
												{Array.isArray(card?.modules) && card.modules.length > 0
													? card.modules.map((m) => {
														return (
															<CoreModuleCard
																setCompanyDashboardTab={setCompanyDashboardTab}
																key={m?._id || m?.moduleKey || m?.moduleName}
																name={m?.moduleName || 'Module'}
																subTitle={m?.moduleSubTitle || ''}
																description={m?.moduleDescription}
																moduleCertification={m?.moduleCertification}
																module={m}
																user={user}
																permissionLevel={permissionLevel}
																type={m?.moduleKey || m?.moduleName}
																setTab={setTab}
																company={company}
																setIsWorkflowReport={setIsWorkflowReport}
																imageURL={m?.imageURL}
																showPercentages={m}
																menus={['listOfSections']}
																reportMenu={m?.['reportMenu']}
															/>
														)
													})
													: null}
											</div>
										</div>
									</div>
								</div>
							)
						})}
					</div>
				)
			}


			{/* Key Feature See More Popup */}
			<Modal id="keyFeatureSeeMore" open={modal['open'] == 'seeMorePopup'} onClose={() => onModalClose()} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore" >
				<div className="poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '1350px' }}>
					{selectedSeeMore &&
						<div className='df w100' >
							<div style={{ width: "55%", height: '100%' }}>
								<div className='df w100 mb1rem'>
									<div className="w10 df aic">{selectedSeeMore?.icon}</div>
									<div className="w90 fw500 c15 pl1rem df aic" style={{ fontSize: '26px', lineHeight: '37.32px' }}>{selectedSeeMore?.title}</div>
								</div>
								{/* custom-list */}
								<ul className=" mt0-5rem" style={{ paddingLeft: '22px' }}>
									{selectedSeeMore?.points?.map((objpoints, index) => {
										return (
											<li style={{ lineHeight: '25px', paddingBottom: "3px", paddingTop: "3px", paddingLeft: "20px", borderLeft: '2px solid #D3D9FC' }} className="df fdc fs1rem c14 fs1rem fw400" key={`${objpoints}-${index}`}>
												<div className="pr">
													<div className="circle"></div>
													{objpoints}
												</div>
												<div>{selectedSeeMore?.subMenu && selectedSeeMore?.subMenu?.index == index &&
													selectedSeeMore?.subMenu?.points?.map((str, i, arr) => {
														return (
															<div className="fs1rem c14 fs1rem fw400 df aic pl2rem" style={{ lineHeight: '30px' }}>{str}</div>
														)
													})
												}
												</div>
											</li>
										)
									})}
								</ul >
								{selectedSeeMore?.notePoint &&
									<div className="mt1rem" style={{ border: '1px solid gray', padding: "10px", borderRadius: '10px' }}>{selectedSeeMore?.notePoint}</div>
								}
							</div>
							<div className="df aic jce" style={{ width: '45%' }}>
								<img src={selectedSeeMore?.image} className="w70" style={{ objectFit: 'fill' }} />
								{selectedSeeMore?.['isStoryVideo'] && <img src={require('../../../../images/videoButton.png')} onClick={() => dispatch(toggleModal({ open: "videoCompanies" }))} className='pa cp zi1' style={{ right: '10%', bottom: '10px' }} />}
							</div>
						</div>
					}
					<svg className="pa cp" onClick={() => onModalClose()} style={{ left: '650px', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

			{/* How It Works Popup (from module card menu) */}
			{modal['open'] === 'howItWorksPopupNew' && (modal?.howItWorksData && Object.keys(modal.howItWorksData).length > 0) && (
				<HowItWorkModal selectedHowItWorks={modal.howItWorksData} />
			)}

			{/* How It Works Popup (legacy) */}
			<Modal id="howItWorksPopup" open={modal['open'] == 'howItWorksPopup'} onClose={() => onModalClose()} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore" >
				<div className="poppins-font-style mah100 bg20 shadow w100 px4rem py2rem df fdc m1rem pr br10px pr" style={{ outline: 'none', zoom: '0.9', maxWidth: '1550px', ...selectedSeeMore?.seeMoreSection?.cardPaddingBottom, }}>
					<div className='df fww w100'>
						{selectedHowItWorks?.['isStoryVideo'] &&
							<div className='df jcc fdc pa' style={{ right: '-7%', top: '-5%' }}>
								<img src={require('../../../../images/landingpage/Cybersecurity_Mask.png')} className="w70" style={{ borderRadius: '50%' }} />
								<img src={require('../../../../images/videoButton.png')} onClick={() => dispatch(toggleModal({ open: "videoCompanies" }))} className='cp zi1' />
							</div>
						}
						<h2 className='w100 tac c15 fs1-75rem fw500'>How does it work?</h2>
						{selectedHowItWorks?.['subTitle'] && <h6 className='w100 tac c15 fs1-25rem fw500 mb1rem'>{selectedHowItWorks?.['subTitle']}</h6>}
						<div className='step-top-box df w100 jcc'>
							<img src={selectedHowItWorks?.['stepImage']} className="w70" style={{ objectFit: 'fill' }} />
						</div>
						<div className='step-box-images df jcsb mt1rem mb2rem mla mra'>
							{(selectedHowItWorks?.['arrayImages'] && selectedHowItWorks?.['arrayImages'].length > 0) ? <>{
								selectedHowItWorks?.['arrayImages'].map(image => {
									return (
										<div className='step-img df jcc px1rem'>
											<img className='' src={image} alt="ste image" />
										</div>
									)
								})
							}</> : null}
						</div>
						{selectedHowItWorks?.['checkList'] &&
							<div className='checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb'>
								{(selectedHowItWorks?.['checkList'] && selectedHowItWorks?.['checkList'].length > 0) && <>{
									selectedHowItWorks?.['checkList'].map(array => {
										return (
											<div className='checklist-inner w100 pr'>{array}</div>
										)
									})
								}</>}
							</div>
						}
						<div className='df jcc w100'>
							{selectedHowItWorks?.['bottomSection'] && <p className='fs1-25rem c12 mb1rem tac w100'>{selectedHowItWorks?.['bottomSection']}</p>}
						</div>
						<div className='df jcc w100'>
							<button>{selectedHowItWorks?.['btnContent']}</button>
						</div>
					</div>
					<svg className="pa cp" onClick={() => onModalClose()} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

			{/* Story Video Modal */}
			<Modal open={modal['open'] == 'videoCompanies'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'>
				<div className='bg1 shadow w100 p2-5rem bsbb df fdc m1rem maw900px br5px pr'>
					<button className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))} >
						<svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' >
							<path className='pen fa-primary' d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z' />
						</svg>
					</button>
					<div style={{ position: 'relative', paddingBottom: '56.25%', height: '0' }}>
						<iframe src={"https://www.loom.com/embed/22404ff9e1514a3ca4a169af00ee93e1?sid=bf8bbfc8-8d7d-4361-9227-cc2876f6bd2d&output=embed"} frameborder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}></iframe>
					</div>
				</div>
			</Modal>

			{/* Director Quastionnaires Disclaimer */}
			<DirectorQuestionnaireDisclaimer />

			{/* See Certificate */}
			<Modal open={modal['open'] == 'seeCertificate'} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className='df jcc onone'>
					<div className={`mah90 oya bg1 shadow w100 pt1rem pl1rem pr1rem pb2rem bsbb df fdc m1rem br20px pr maw50`}>
						<div className="df jcsb aic fdc step-box-modal">
							<div className='step-box-box-1 tac w100'>
								<img className='w200px ma' src={require('../../../../images/seeCertificate.png')} alt='' />
								<h1 className="c15 fs2rem fw400 mb1rem">Oops!</h1>
							</div>
							<p className='tac c15 op60 maw80 px2rem fs1rem lh1-5rem'>Sorry, but can only access this module if you have Diligentsia Gold certification. This is to preserve the quality of qualified and diligenced leads we introduce to investors on our investor database. We look forwards to seeing you soon once you have achieved gold!</p>
						</div>
						<div className='df jcc mt1rem'>
							<Link
								to={`#unaudited-certification`}
								className='p1rem pl4rem pr4rem shadow c1 bg4 bg3-hover br35px mt1rem mb1rem mr2-5rem cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation'
								onClick={() => {
									dispatch(toggleModal({ open: '' }));
									setModuleTab(setTab, 'unaudited-certification')
								}}
							>
								See Certification status
							</Link>
						</div>
					</div>
					<svg className="pa cp" onClick={() => { dispatch(toggleModal({ open: '' })), resetStates() }} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '100px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal >

			{/* Generate Partner Popup */}
			<Modal id="generatePartnerPopup" open={modal['open'] == 'generatePartnerPopup'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore">
				<div className="poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '750px' }}>
					<div className='top-logo pa t0 r0 mr1rem mt1rem'><img className='w4rem' src={require('../../../../images/favicon.png')} alt="" /></div>
					<div className='creaing-modal pr mb3rem'>
						<div className='df jcc'><img className="w10rem" src={require('../../../../images/wizard.gif')} alt="" /></div>
						<div className='text-box w90 df jcc tac fdc mla mra'>
							<h3 className='fs1-5rem c15 mb1rem'>Performing checklist creation magic!</h3>
							<div className="my1rem tac">
								<div className="checklist-progress"><div className={`checklist-progress-bar module-progress-bar`}></div></div>
							</div>
							<p className='c15 fs1rem mt1rem'>This may take couple of minutes to generate checklist.</p>
						</div>
					</div>
				</div>
			</Modal>

			{/* Dashboard What to Next Modal */}
			<WhatToDoNextModal Objective={company['testType']} subscription={company['subscription']} company={company} />
			<WhatYouGetModal Objective={company['testType']} subscription={company['subscription']} company={company} showExpension={showExpension} setShowExpension={setShowExpension} user={user} />

			<SubscriptionPaymentConfirm
				plan={modal.purchasePlan || 'Pro'}
				defaultStep={modal.purchaseDefaultStep}
				companyId={company?._id}
				company={company}
				module={modal.modulePurchase}
				setShowExpension={() => { }}
			/>

			{/* Demo Checklist Flow */}
			<Modal id="swotReportPopup" open={modal['open'] == 'swotReportPopup'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore">
				<div className="poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '750px' }}>
					<div className='top-logo pa t0 r0 mr1rem mt1rem'><img className='w4rem' src={require('../../../../images/favicon.png')} alt="" /></div>
					<div className='df fdc my3rem'>
						<div className='df fdc'>
							<h3 className='fs1-5rem c15 mb1-5rem'>SWOT Analysis Report</h3>
							{isSwotReport
								? <p className="fs1rem c15 mb1rem tac">Generate the other ResearchAid reports before <br /> generating the SWOT Report</p>
								: <p className="fs1rem c15 mb1rem tac">The SWOT report will produce better results if you first generate  <br /> the Technology Competitive Advantage Report</p>
							}
						</div>
						{isSwotReport
							? <div className='df jcc mt2rem'>
								<button onClick={() => dispatch(toggleModal({ open: '' }))} className="bg4 fs0-75rem fw600 c1 td250 br30px px4rem py0-5rem cp tac">Back</button>
							</div>
							: <div className='df jcsa mt2rem'>
								<button onClick={() => dispatch(toggleModal({ open: '' }))} className="bg4 fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac">Cancel</button>
								<Link to={((user['role'] != 'Advisor' && user['role'] != 'Investor') || (user?.['companyId']?.['_id'] == company?.['_id'])) && `/researchAid/${company['_id']}?swotAnalysis`}
									data-tooltip={((user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] != company?.['_id']) ? `${user['role']} can't generate report from company dashboard!` : ''}
									state={{ company }} className={`fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac ${((user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] != company?.['_id']) ? 'cna bg16' : 'cp bg3'}`}>Generate</Link>
							</div>
						}
					</div>
					<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>
		</>
	)
}